import React, { useState, useEffect } from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  passwordKey: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, passwordKey }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Check local storage for authentication on mount
  useEffect(() => {
    const authStatus = localStorage.getItem(`auth_${passwordKey}`);
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, [passwordKey]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Check the password against our expected value
    if (password === 'withloveNOPRBLM') {
      localStorage.setItem(`auth_${passwordKey}`, 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  if (isLoading) {
    return (
      <div className="password-protection loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="password-protection">
        <div className="password-container">
          <h1>Restricted Access</h1>
          <p>Please enter the password to view this page.</p>
          {error && <div className="password-error">{error}</div>}
          <form onSubmit={handleSubmit} className="password-form">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="password-input"
              autoFocus
            />
            <button type="submit" className="password-submit">Enter</button>
          </form>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;